import { useNavigate } from 'react-router-dom'
import { Button } from '../../../components/Button/Button'
import { MeetingTemplateInfo } from '../../../apps/professional-app/fa/MeetingSummary/MeetingTemplateInfo/MeetingTemplateInfo'
import React, { useMemo } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectEmailThreads } from '../../../store/emailHub/emailThreads'
import { formatDate } from '../../../apps/professional-app/fa/common/aifeatures/utils'
import { selectCurrentUserEmailIntegration } from '../../../store/emailHub/emailUsers'
import { IntegrationServiceId } from '../../../common/integrations'
import './EmailHeader.scss'
import { IntegrationIcon } from '../../../components/IntegrationIcon'

export interface EmailHeaderProps {
  threadId: string
}

export const EmailHeader: React.FC<EmailHeaderProps> = ({ threadId }) => {
  const navigate = useNavigate()

  const emailIntegration = useAppSelector(selectCurrentUserEmailIntegration)

  const getConnectorIcon = () => {
    if (!emailIntegration) {
      return null
    }

    const { serviceId } = emailIntegration
    if (serviceId === IntegrationServiceId.GMAIL) {
      return <IntegrationIcon serviceId={IntegrationServiceId.GMAIL} width={24} height={24} />
    }
    if (serviceId === IntegrationServiceId.OUTLOOK_MAIL) {
      return <IntegrationIcon serviceId={IntegrationServiceId.OUTLOOK_MAIL} width={24} height={24} />
    }
    return null
  }

  const handleBackButtonClicked = () => {
    navigate({
      pathname: '/email/inbox',
      // todo searchparams
    })
  }

  return (
    <div className='d-flex flex-column'>
      <div className='d-flex zocks-pl-2.0 justify-content-between align-items-center'>
        <div className='d-flex gap-3 align-items-center'>
          <div className='d-flex align-items-center justify-content-center zocks-border-0.25 zocks-bg-color-gray-200 email-connector-icon '>
            {getConnectorIcon()}
          </div>
          <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
            <i className='bi bi-chevron-left' />
          </Button>
          <EmailHeaderContent threadId={threadId} />
        </div>
      </div>
      <MeetingTemplateInfo />
    </div>
  )
}

interface EmailHeaderContentProps {
  threadId: string
}

const EmailHeaderContent: React.FC<EmailHeaderContentProps> = ({ threadId }) => {
  const emailThreads = useAppSelector(selectEmailThreads)

  const emailThread = emailThreads.find((thread) => thread.externalId === threadId)

  const uniqueSenders = useMemo(() => {
    if (!emailThread) {
      return 0
    }
    return new Set(emailThread.emails.map((email) => email.sender.email.toLowerCase())).size
  }, [emailThread])

  if (!emailThread) {
    return null
  }

  return (
    <div className='d-flex flex-column'>
      <div className='paragraph-large bold'>{emailThread.emails[0].subject}</div>
      <div className='d-flex gap-3'>
        <div className='d-flex gap-2 align-items-center'>
          <i className='bi bi-calendar4' />
          <div className='paragraph-small zocks-text-gray-600'>{formatDate(emailThread.emails[0].createdAt)}</div>
        </div>
        <div className='d-flex gap-2 align-items-center'>
          <i className='bi bi-people' />
          <div className='paragraph-small zocks-text-gray-600'>{uniqueSenders}</div>
        </div>
      </div>
    </div>
  )
}
